import { useEffect, useState } from "react";
import { Container, FormControlLabel, Grid, Switch } from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router";

import MaskService from "../../../utils/mask/maskService";
import HeaderModule from "../../../components/header/HeaderModule";
import { PainelContainer, TableContent } from "./styles/Transportadora";
import Btn from "../../../components/buttons/Btn";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import useTransportadoraeController from "./controllers/TransportadoraController";
import Loading from "../../../components/basics/Loading";

import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";

import { BallContainer } from "./styles/Transportadora";
import BigDataTable from "../../../components/tables/BigDataTable";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import WhatsappButton from "../../../components/whatsappButton/WhatsappButton";
import { GlobalVariables } from "../../../GlobalVariables";

let typingTimer = null;
const TransportadoraListagem = () => {
  // eslint-disable-next-line
  const [viewLoading, setViewLoading] = useState(false);
  // eslint-disable-next-line
  const [reload, setReload] = useState(false);

  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);
  const [queryOrWhere, setQueryOrWhere] = useState(null);
  const [queryOrWhereTranslate, setQueryOrWhereTranslate] = useState(null);
  const [queryWhere, setQueryWhere] = useState({ status: "" });

  // eslint-disable-next-line
  const { handleClearContext, handleDeleteItem } =
    useTransportadoraeController();
  const { push } = useHistory();

  const columns = [
    {
      disabled: true,
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlinedIcon />,
              name: "Editar",
              action: () => push("cadastro", { item }),
            },
            // {
            //   icon: <DeleteOutlined />,
            //   name: "Excluir",
            //   action: () =>
            //     handleDeleteItem(item.id, setViewLoading, setReload),
            // },
          ]}
        />
      ),
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "cnpj_cpf",
      label: "CNPJ/CPF",
      format: (item) =>
        item.cnpj_cpf
          ? MaskService.toMask(
              item.cnpj_cpf.replace(/[^0-9]+/g, "").length === 14
                ? "cnpj"
                : "cpf",
              item.cnpj_cpf
            )
          : "-",
    },
    {
      id: "razao",
      label: "Razão",
    },
    {
      id: "apelido",
      label: "Fantasia",
    },
    {
      id: "email1",
      label: "E-mail",
    },
    {
      disabled: true,
      id: "telefone1",
      label: "Telefone",
      format: (value) =>
        value.ddd1 && value.telefone1
          ? `(${value.ddd1}) ${value.telefone1}`
          : "-",
    },
    {
      id: "celular",
      label: "Celular",
      format: (item) =>
        item.whatsapp_ativo === 1 && <WhatsappButton celular={item.celular} />,
    },
    {
      id: "cidade",
      label: "Cidade",
    },
    {
      id: "status",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.status === 1 ? (
          <BallContainer>
            <img src={GreenBall} alt="ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="inativo" />
          </BallContainer>
        ),
    },
  ];

  const columnsForFilter = [
    "acoes",
    "razao",
    "apelido",
    "cnpj_cpf",
    "email1",
    "telefone1",
    "status",
  ];

  useEffect(() => {
    handleClearContext();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setQueryOrWhere({
        razao: encodeURIComponent(`${textFilter}`),
        apelido: encodeURIComponent(`${textFilter}`),
        id: `${textFilter.replace(/[^0-9]/g, "") || null}`,
        email1: encodeURIComponent(`${textFilter}`),
        telefone1: encodeURIComponent(`${textFilter}`),
      });

      setQueryOrWhereTranslate({
        cnpj_cpf: textFilter,
      });
    }, 1500);
  }, [textFilter]);

  useEffect(() => {
    setQueryWhere({ status: showOnlyActives ? "1" : "0" });
  }, [showOnlyActives]);

  return (
    <>
      <Loading open={viewLoading} />
      <HeaderModule
        title="CADASTRO DE TRANSPORTADORAS"
        videoId={GlobalVariables.screenVideosIds.cadastroTransportadora}
      />

      <PainelContainer />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item container justify="space-between" alignItems="flex-end">
            <Grid item xs={12} sm={12} md={7}>
              <TextFieldErp
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Razão, Fantasia, CPF/CNPJ/CÓD, Email ou Telefone"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<AddIcon />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TableContent>
              <BigDataTable
                tableTitle=""
                route="prouser/transportadoras/v1"
                fields={{
                  "prouser.transportadoras":
                    "id,razao,apelido,cnpj_cpf,email1,telefone1,ddd1,status,cidade,celular,whatsapp_ativo",
                }}
                columns={columns.filter((column) =>
                  textFilter ? columnsForFilter.includes(column.id) : true
                )}
                where={queryWhere}
                orWhere={queryOrWhere}
                orWhereTranslate={queryOrWhereTranslate}
                reload={reload}
              />
            </TableContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default TransportadoraListagem;
